import React, { useEffect, useRef } from 'react';
import { LogOut, Settings } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { APP_BASE_URL } from '../config';

const ProfileDropdown = ({ user, onLogout, onClose }) => {
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const avatar = user?.photo
    ? `${APP_BASE_URL}/uploads/profilephoto/${user.adminID}/profilePic/${user.photo}`
    : null;

  const initials = user?.name
    ? user.name
        .split(' ')
        .map((n) => n[0])
        .join('')
        .substring(0, 2)
        .toUpperCase()
    : 'U';

//  useEffect(() => {
//   const handleClickOutside = (event) => {
//     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//       onClose(); // or setShowProfileDropdown(false)
//     }
//   };

//   const timeout = setTimeout(() => {
//     document.addEventListener('mousedown', handleClickOutside);
//   }, 0); // defer to next tick

//   return () => {
//     clearTimeout(timeout);
//     document.removeEventListener('mousedown', handleClickOutside);
//   };
// }, []);
  return (
    <>
    <div className="absolute top-12 right-5 -translate-y-1/2 w-4 h-4 bg-white rotate-45 shadow z-0"/>
    <div
      ref={dropdownRef}
      className="absolute right-0 top-12 w-80 bg-white rounded-xl shadow-2xl ring-1 ring-black ring-opacity-5 z-50 animate-fadeDropdown"
    >
      {/* Arrow */}
      

      {/* Header */}
      <div className="relative z-10 px-4 py-4 flex items-center gap-3 border-b">
        {avatar ? (
          <img
            src={avatar}
            alt={user.name}
            className="w-12 h-12 rounded-full object-cover"
          />
        ) : (
          <div className="w-12 h-12 bg-indigo-700 text-white rounded-full flex items-center justify-center font-semibold text-lg">
            {initials}
          </div>
        )}
        <div>
          <div className="text-gray-900 font-semibold text-base">{user.name}</div>
          <div className="text-sm text-gray-500 truncate">{user.email}</div>
        </div>
      </div>

      {/* Feature Prompt */}
      <div className="bg-gray-50 px-4 py-3 text-sm text-gray-700 border-b">
        <p className="mb-1 leading-snug">Missing out on a feature? We'd love to know!</p>
        <a
          href="https://www.webtrix24.com"
          className="text-indigo-600 font-medium hover:underline"
        >
          Request a Feature ↗
        </a>
      </div>

      {/* Menu */}
      <div className="px-4 py-2">
        <button
          className="w-full text-left flex items-center gap-2 px-2 py-2 rounded hover:bg-gray-100 text-gray-800 text-sm"
          onClick={() => navigate('/my/settings')}
        >
          <Settings size={16} />
          User Settings
        </button>
        <button
          className="w-full text-left flex items-center gap-2 px-2 py-2 rounded hover:bg-gray-100 text-red-600 text-sm"
          onClick={onLogout}
        >
          <LogOut size={16} />
          Logout
        </button>
      </div>

      {/* Footer */}
      <div className="border-t text-xs text-gray-400 px-4 py-3 flex justify-around">
        <a href="https://www.webtrix24.com/blogs" className="hover:underline">Blog</a>
        <a href="https://www.webtrix24.com/Features" className="hover:underline">About</a>
        <a href="https://www.webtrix24.com/privacy-policy" className="hover:underline">Privacy</a>
        <a href="https://www.webtrix24.com/Knowledge-Base" className="hover:underline">FAQs</a>
      </div>
    </div>
    </>
  );
};

export default ProfileDropdown;
